
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AmendmentAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pathBuilder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"any"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partyMembers"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PartyMember"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pitchId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"PartyMembers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partyMembers"}}},{"kind":"Argument","name":{"kind":"Name","value":"FromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"ToDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"Argument","name":{"kind":"Name","value":"PitchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pitchId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"rest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"Availability","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"pathBuilder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pathBuilder"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pitchTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amendmentFee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberAvailability"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberMinPricePerNight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberAvailabilityTotalPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonMemberAvailability"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonMemberMinPricePerNight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonMemberAvailabilityTotalPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numFreeNights"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasLowAvailability"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"daysOnRequest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restrictions"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":674}};
    doc.loc.source = {"body":"query AmendmentAvailability(\n  $pathBuilder: any,\n  $partyMembers: [PartyMember]\n  $start: String!,\n  $end: String!,\n  $pitchId: String,\n  $skip: Boolean\n) {\n  availability (\n    PartyMembers: $partyMembers,\n    FromDate: $start,\n    ToDate: $end\n    PitchId: $pitchId,\n  ) @rest(\n    type: \"Availability\",\n    pathBuilder: $pathBuilder,\n  ) {\n    pitchTypes {\n      amendmentFee\n      code\n      memberAvailability\n      memberMinPricePerNight\n      memberAvailabilityTotalPrice\n      nonMemberAvailability\n      nonMemberMinPricePerNight\n      nonMemberAvailabilityTotalPrice\n      numFreeNights\n      hasLowAvailability\n      daysOnRequest\n      restrictions\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AmendmentAvailability"] = oneQuery(doc, "AmendmentAvailability");
        
